import { LISTING_PAGE_REDUCER } from './reducer';

const _selectListingPageReducer = (state) => state[LISTING_PAGE_REDUCER];

// Listing page specific data.

export const selectAvailableCityStates = (state) =>
  _selectListingPageReducer(state).availableCitiesAndStates;
